import React from "react"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { EditSchedulerJobFormValues, JobScheduleInfo } from "../schedulerTypes"
import { makeStyles } from "tss-react/mui"
import { useFormikContext } from "formik"
import { DateTimePicker, renderTimeViewClock } from "@mui/x-date-pickers"
import { Stack, Typography } from "@mui/material"
import { useDateTime } from "../../../../../localization/useDateTime"

const useStyles = makeStyles()(() => ({
    input: {
        width: "25rem",
    },
}))

export function EditSchedulerJobFromContent({ jobInformation }: { jobInformation: JobScheduleInfo }) {
    const { classes } = useStyles()
    const { values, setFieldValue } = useFormikContext<EditSchedulerJobFormValues>()
    const dateTimeFactory = useDateTime()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict
                    id="support-reports-health-schedule-edit-page-start-time-label"
                    attrs={{ label: true }}
                >
                    <DateTimePicker
                        className={classes.input}
                        value={values.startTime}
                        onChange={(newValue) => {
                            if (newValue) {
                                setFieldValue("startTime", newValue)
                            }
                        }}
                        viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                        }}
                        format={"MM/dd/yyyy\u00A0hh:mm\u00A0a"}
                        label="Start time"
                    />
                </LocalizedStrict>
                <LocalizedStrict
                    id="support-reports-health-schedule-edit-page-cron-expression-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField<EditSchedulerJobFormValues>
                        name="cronExpression"
                        label="Cron expression"
                        className={classes.input}
                        fullWidth
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="support-reports-health-schedule-edit-page-settings-title" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="support-reports-health-schedule-edit-page-settings-active-label">
                        <FormikSwitch name="status">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            <LocalizedStrict id="support-reports-health-schedule-edit-page-information-title" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Information">
                    <Stack spacing="2rem">
                        <Stack>
                            <LocalizedStrict id="support-reports-health-schedule-edit-page-information-id">
                                <Typography>ID:</Typography>
                            </LocalizedStrict>
                            <Typography variant="subtitle1">{jobInformation.id}</Typography>
                        </Stack>
                        <Stack>
                            <LocalizedStrict id="support-reports-health-schedule-edit-page-information-name">
                                <Typography>Name:</Typography>
                            </LocalizedStrict>
                            <Typography variant="subtitle1">{jobInformation.name}</Typography>
                        </Stack>
                        <Stack>
                            <LocalizedStrict id="support-reports-health-schedule-edit-page-information-last-run">
                                <Typography>Last run:</Typography>
                            </LocalizedStrict>
                            <Typography variant="subtitle1">
                                {jobInformation.lastRun
                                    ? dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(jobInformation.lastRun))
                                    : "-"}
                            </Typography>
                        </Stack>
                    </Stack>
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
